package one.primehealth.app

data class PlatformValues<T>(
    val android: T,
    val ios: T,
    val web: T,
) {
    operator fun invoke(): T {
        return when (targetPlatform()) {
            TargetPlatform.Android -> android
            TargetPlatform.iOS -> ios
            TargetPlatform.Web -> web
        }
    }

    companion object {
        fun createMobileOnly(): PlatformValues<Boolean> {
            return PlatformValues(
                android = true,
                ios = true,
                web = false
            )
        }
    }
}